import {ValueObject} from '@s-ui/domain'

import {QueryParamSharedValueObject} from '../../shared/ValueObjects/QueryParamSharedValueObject.js'
import {FilterBooleanSearchValueObject} from './FilterBooleanSearchValueObject.js'

export class FilterHasWarrantySearchValueObject extends ValueObject {
  #hasWarranty

  constructor({hasWarranty}) {
    super()
    this.#hasWarranty = hasWarranty
  }

  static create({hasWarranty}) {
    return new FilterHasWarrantySearchValueObject({hasWarranty: FilterBooleanSearchValueObject.create(hasWarranty)})
  }

  static createWithDefaultValue({config, hasWarranty}) {
    const {DEFAULT_HAS_WARRANTY_SEARCH} = config.get('searchFilters')

    return new FilterHasWarrantySearchValueObject({
      hasWarranty: FilterBooleanSearchValueObject.create({boolean: hasWarranty ?? DEFAULT_HAS_WARRANTY_SEARCH})
    })
  }

  static createQueryParams({config, hasWarranty}) {
    const {FILTER_NAMES, FILTER_QUERY_PARAMS} = config.get('searchFilters')

    return new FilterHasWarrantySearchValueObject({
      hasWarranty: QueryParamSharedValueObject.createForSingle({
        key: FILTER_QUERY_PARAMS[FILTER_NAMES.HAS_WARRANTY],
        value: hasWarranty === true ? hasWarranty : null
      })
    })
  }

  get isEmpty() {
    return this.#hasWarranty.isEmpty
  }

  get queryParams() {
    return {
      ...(!this.isEmpty && {...this.#hasWarranty.queryParam})
    }
  }

  get value() {
    return this.#hasWarranty.value
  }

  toJSON() {
    return {
      hasWarranty: this.#hasWarranty.toJSON()
    }
  }
}
